export const formatPercentageInput = (value: string, maxValue: number) => {
  let input = value.replace(/\s+/g, '');

  if (input === '') return { value: '', error: null };

  if (!/^\d*[.,]?\d*$/.test(input)) {
    return { value: '', error: 'numeric-error' };
  }

  if (input.startsWith('.') || input.startsWith(',')) {
    input = '0' + input;
  }

  if (input.includes('.') || input.includes(',')) {
    const separator = input.includes(',') ? ',' : '.';
    let [intPart, decPart = ''] = input.split(separator);
    input = `${intPart}${separator}${decPart.slice(0, 4)}`;
  }

  const normalized = input.replace(',', '.');

  const number = Number(normalized.endsWith('.') ? normalized.slice(0, -1) : normalized);

  if (!Number.isNaN(number) && number > maxValue) {
    return { value: input, error: `value-exceed-${maxValue}` };
  }

  return { value: input, error: null };
};
